export class InvMasterInitEntity {

    id:number;
    pallet:string;
    codigoSap:string;
    location:string;
    typology:string;
    status:string;
    active:boolean;
    creationDate:string;
    userIdCreation:number;
    updateDate:string;
    userIdUpdate:number;
    userCreation:string;
    userUpdate:string;
    userAuthorization:number

    constructor() { }
}